import React, { type ReactElement } from 'react';

import classNames from 'classnames';

export interface DetailContainerProps {
  detail: string;
  className?: string;
}

export default function DetailContainer({
  detail,
  className,
}: DetailContainerProps): ReactElement {
  return (
    <div
      className={classNames(
        'absolute z-30 flex items-center justify-center rounded-[10px] bg-black-600 p-1 text-center text-xs text-white',
        className
      )}
    >
      <span>{detail}</span>
    </div>
  );
}
